export const majors = [
  {
    keywords: ['Y đa khoa'],
    value: 'Y đa khoa',
  },
  {
    keywords: ['Bác sĩ răng hàm mặt'],
    value: 'Bác sĩ răng hàm mặt',
  },
  {
    keywords: ['Y học cổ truyền'],
    value: 'Y học cổ truyền',
  },
  {
    keywords: ['Y học dự phòng'],
    value: 'Y học dự phòng',
  },
  {
    keywords: ['Dược khoa'],
    value: 'Dược khoa',
  },
  {
    keywords: ['Hoá dược'],
    value: 'Hoá dược',
  },
  {
    keywords: ['Điều dưỡng đa khoa'],
    value: 'Điều dưỡng đa khoa',
  },
  {
    keywords: ['Hộ sinh'],
    value: 'Hộ sinh',
  },
  {
    keywords: ['Y tế công cộng'],
    value: 'Y tế công cộng',
  },
  {
    keywords: ['Tổ chức và quản lý y tế'],
    value: 'Tổ chức và quản lý y tế',
  },
  {
    keywords: ['Quản lý bệnh viện'],
    value: 'Quản lý bệnh viện',
  },
  {
    keywords: ['Kỹ thuật xét nghiệm y học'],
    value: 'Kỹ thuật xét nghiệm y học',
  },
  {
    keywords: ['Kỹ thuật hình ảnh y học'],
    value: 'Kỹ thuật hình ảnh y học',
  },
  {
    keywords: ['Kỹ thuật phục hồi chức năng'],
    value: 'Kỹ thuật phục hồi chức năng',
  },
  {
    keywords: ['Kỹ thuật phục hình răng'],
    value: 'Kỹ thuật phục hình răng',
  },
  {
    keywords: ['Y sĩ đa khoa'],
    value: 'Y sĩ đa khoa',
  },
  {
    keywords: ['Dinh Dưỡng'],
    value: 'Dinh Dưỡng',
  },
];
